<template>
    <el-dialog
        :title="`Inactivate Campaign ${campaign_name}`"
        :visible.sync="showForm"
        :destroy-on-close="true"
        width="85%"
        append-to-body
        :before-close="closeDialog"
        @open="refresh">
        <div v-loading="loading">
            <template v-if="job_count > 0">
            <h5 style="margin-top: 30px;">Jobs</h5>
            <campaign-job-list :employer_id="employer_id"
                               :campaign_id="campaign_id"
                               @updated="() => jobs_updated = true"
                               :campaign_options="campaign_options"></campaign-job-list>

            <h5 style="margin-top: 30px;">With jobs assigned to campaign</h5>

            <div class="cd-section">
                <div style="display: flex; align-items: center">
                    <el-radio v-model="formData.action" label="reassign_jobs">Reassign jobs to</el-radio>

                    <el-select v-model="formData.new_campaign_id" filterable placeholder="New Campaign" style="width: 350px; margin: 0 15px;">
                        <el-option
                            v-for="(option) in campaign_options"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>

                </div>

                <div style="display: flex; align-items: center; margin-top: 20px;">
                    <el-radio v-model="formData.action" label="inactivate_jobs">Inactivate jobs</el-radio>
                </div>
            </div>
            </template>
            <template v-else>
                <div>
                    The campaign has no jobs, feel free to inactivate.
                </div>
            </template>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">Close</el-button>
            <el-button type="danger" @click="save">Inactivate Campaign</el-button>
        </span>
    </el-dialog>
</template>

<script>
import CampaignJobList from "../../Job/vue/campaigns/campaign-job-list";

export default {
    components: {CampaignJobList},
    props: [
        'show',
        'employer_id',
        'campaign_id',
    ],
    data() {
        return {
            formData: {
                action: 'inactivate_jobs',
                new_campaign_id: null,
            },
            loading: true,
            job_count: 0,
            campaign_name: '',
            campaign_options: [],
            jobs_updated: false,
        };
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`admin/employer/${this.employer_id}/campaigns/dropdown`))
                .then(response => {
                    this.campaign_options = response.data;
                    this.loading = false;
                });

            return axios.get(url(`admin/employer/${this.employer_id}/campaigns/${this.campaign_id}/detail`))
                .then(response => {
                    this.campaign_name = response.data.campaign.name;
                    this.job_count = response.data.job_count;
                    this.loading = false;
                });
        },
        openAddJobsDialog() {
            this.show_dialogs.add_jobs = true;
        },
        save() {
            return axios.post(url(`admin/employer/${this.employer_id}/campaigns/${this.campaign_id}/inactivate`), {
                action: this.formData.action,
                move_to_campaign_id: this.formData.new_campaign_id
            }).then(response => {
                this.showForm = false;
                this.$emit('updated');
            })
        },
        closeDialog() {
            if (this.jobs_updated) {
                this.$emit('updated');
            }
            this.showForm = false;
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>